import type { OnboardingValues, StepField, StepFieldName } from "../types";

type InputProps = {
  currentField: StepField;
  values: OnboardingValues;
  handleFieldChange: (fieldName: StepFieldName, value: string) => void;
  error?: string;
  onEnterPress?: () => void;
};

const Input = ({
  currentField,
  values,
  handleFieldChange,
  error,
  onEnterPress,
}: InputProps) => {
  return (
    <div className="flex flex-col gap-[6px]">
      <div
        className={`autofill-within:bg-[rgba(42,130,211,0.10)] rounded-[16px] p-[4px] transition-colors focus-within:bg-[rgba(42,130,211,0.10)] ${
          error ? "bg-[rgba(251,95,102,0.06)]" : "bg-[#F9F9F9]"
        }`}
      >
        <input
          className={`w-full rounded-[12px] border bg-white p-[15px] transition-colors placeholder:text-[rgba(102,102,102,0.60)] autofill:!bg-white focus:outline-none ${
            error
              ? "border-[#FB5F66] focus:border-[#FB5F66]"
              : "border-[rgba(0,0,0,0.10)] autofill:border-[#64A8F2] focus:border-[#64A8F2]"
          }`}
          name={currentField.name}
          placeholder={currentField.placeholder}
          type="text"
          value={values[currentField.name]}
          onChange={(event) =>
            handleFieldChange(currentField.name, event.target.value)
          }
          onKeyDown={(event) => {
            if (event.key === "Enter" && onEnterPress) {
              event.preventDefault();
              onEnterPress();
            }
          }}
        />
      </div>
      {error && (
        <p className="flex items-center gap-[5px] px-[4px] text-[12px] font-medium leading-[130%] text-[#FB5F66]">
          <svg
            width="13"
            height="13"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            style={{ flexShrink: 0 }}
          >
            <circle cx="8" cy="8" r="7" stroke="#FB5F66" strokeWidth="1.5" />
            <path
              d="M8 5v3.5"
              stroke="#FB5F66"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <circle cx="8" cy="11.5" r="0.75" fill="#FB5F66" />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
